export const SBOM_EVENT_TO_BOMBINO = 'SBOM-event-to-Bombino';
export const REPO_PUSH = 'repo_push';
export const PLACEHOLDER = '<PLACEHOLDER>';
export const NO_RESULTS = 'no results';
export const TYPEAHEAD_THRESHOLD = 10;
export const KONFLUX_INFO_NAMESPACE = 'konflux-info';

// Session Storage Keys
export const SESSION_STORAGE_KEYS = {
  PIPELINES_VISIBLE_COLUMNS: 'pipeline-runs-columns',
  COMMITS_VISIBLE_COLUMNS: 'commits-visible-columns',
  RELEASES_VISIBLE_COLUMNS: 'releases-visible-columns',
  RELEASE_PIPELINE_VISIBLE_COLUMNS: 'release-pipeline-visible-columns',
} as const;
